import { AnalyticsService } from './AnalyticsService';
import { BaseService } from './BaseService';
import { DOMService } from './DOMService';
import { AnalyticsServiceImpl } from './impl/AnalyticsServiceImpl';
import { DOMServiceImpl } from './impl/DOMServiceImpl';
import { IncomingActionServiceImpl } from './impl/IncomingActionServiceImpl';
import { LogServiceImpl } from './impl/LogServiceImpl';
import { ScreenSharingServiceImpl } from './impl/ScreenSharingServiceImpl';
import { VOServiceImpl } from './impl/VOServiceImpl';
import { WidgetServiceImpl } from './impl/WidgetServiceImpl';
import { IncomingActionService } from './IncomingActionService';
import { LogService } from './LogService';
import { ScreenSharingService } from './ScreenSharingService';
import { ServiceConfiguration } from './ServiceConfiguration';
import { VOService } from './VOService';
import { WidgetService } from './WidgetService';

const log: LogService = new LogServiceImpl();
const widget: WidgetService = new WidgetServiceImpl();
const incomingAction: IncomingActionService = new IncomingActionServiceImpl();
const vo: VOService = new VOServiceImpl();
const analytics: AnalyticsService = new AnalyticsServiceImpl();
const dom: DOMService = new DOMServiceImpl();
const sharing: ScreenSharingService = new ScreenSharingServiceImpl();

export type WidgetServices = typeof services;
export const services = {
    log,
    widget,
    incomingAction,
    vo,
    analytics,
    dom,
    sharing,
};

export const configureServices = (config: ServiceConfiguration) => {
    Object.values(services).forEach((service: BaseService) => service.configure(config));

    widget.services = services;
};
